import React from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../../components/NtText";
import colors from "../../../config/colors";

function NtSectionDescription({ style, ...otherProbs }) {
  return <NtText style={[styles.text, style]} {...otherProbs} />;
}

const styles = StyleSheet.create({
  text: {
    fontSize: 15,
    color: "white",
    fontWeight: "300",
    lineHeight: 19,
  },
});

export default NtSectionDescription;
